import { getAuthUser, updateAuthUser } from '../user/functions'

import type { UserPreference } from './types'

type PrefMapper<T> = (value: string | null) => T;

export function getUserPreference<T>(target: string, mapper: PrefMapper<T>, user = getAuthUser()) {
    if (!user?.preferences) return mapper(null);

    const pref = user.preferences.find(({ key }) => key === target);
    if (!pref) return mapper(null);

    return mapper(pref.value);
}

export function getUserJsonPreference<T>(target: string, mapper: PrefMapper<T>, user = getAuthUser()) {
    if (!user?.preferences) return mapper(null);

    const pref = user.preferences.find(({ key }) => key === target);
    if (!pref) return mapper(null);

    return mapper(pref.valueJson);
}

export function addUserPreference(preference: UserPreference) {
    const user = getAuthUser()
    if (!user) throw new Error('User not logged in')

    const current = user.preferences ?? [];
    const idx = current.findIndex(({ key }) => key === preference.key);

    if (idx >= 0) {
        const preferences = [...current];
        const { value, valueJson } = preference
        preferences[idx] = {...current[idx], valueJson, value}

        return updateAuthUser({...user, preferences})
    }

    return updateAuthUser({
        ...user,
        preferences: [...current, preference],
    });
}

export function removeUserPreference(preference: string | UserPreference) {
    const user = getAuthUser()
    if (!user) throw new Error('User not logged in')

    const current = user.preferences ?? []
    const idx = current.findIndex(({ key }) => {
        return typeof preference === 'string'
            ? key === preference
            : key === preference.key
    })

    if (idx >= 0) {
        const preferences = [...current]
        preferences.splice(idx, 1)

        return updateAuthUser({ ...user, preferences })
    }
}
